import { useEffect, useState } from 'react';
import QRCode, { QRCodeToDataURLOptions } from 'qrcode';
import React from 'react';

type IQRCodeComponentProps = {
  url: string;
  width?: number;
  height?: number;
  options?: QRCodeToDataURLOptions;
};

const QRCodeComponent: React.FC<IQRCodeComponentProps> = (props) => {
  const { url, width, height, options } = props;
  const [qrCodeSrc, setQrCodeSrc] = useState<string>('');

  useEffect(() => {
    QRCode.toDataURL(url, options)
      .then((url) => {
        setQrCodeSrc(url);
      })
      .catch((err) => {
        console.error('Error generating QR Code:', err);
      });
  }, [url]);

  return qrCodeSrc ? <img width={width} height={height} src={qrCodeSrc} alt='QR Code' /> : null;
};

export default QRCodeComponent;
